import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { holidayJson } from "../../../DynamicFormsJson/MastersJSON/holiday";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class HolidayMasterView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            DataToSet: [],
        };
    }

    async componentDidMount() {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            if (this.props.params.id) {
                const monthNames = [
                    "", "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];

                showLoador({ loador: true });
                await apiGet({
                    url: holidayJson.apiBaseURL + "/" + this.props.params.id,
                }).then(({ data, success }) => {
                    if (!success) {
                    } else {
                        this.setState({
                            DataToSet: [
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "Holiday",
                                    value:
                                        data.data !== null && data.data.name !== null
                                            ? data.data.name
                                            : "",
                                },
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "Day",
                                    value:
                                        data.data !== null && data.data.day !== null
                                            ? data.data.day.toString().padStart(2, "0")
                                            : "",
                                },
                                {
                                    xs: 12,
                                    sm: 3,
                                    md: 3,
                                    lg: 3,
                                    label: "Month",
                                    value: data.data !== null && data.data.month !== null
                                        ? monthNames[data.data.month] : "",
                                },
                            ],
                        });
                    }
                });
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    render() {
        const { dynamicMasterData, DataToSet } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        showBackToList={true}
                        DataToSet={DataToSet}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={"Leave Year View"}
                        fieldMeta={[]}
                        apiBaseURL={holidayJson.apiBaseURL}
                        showSaveNextBtn={[]}
                        saveBtnText={"Search"}
                        showSaveBtnMain={false}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayMasterView);
